import React from 'react';

const NA = <span className="fc-na-cell">N/A</span>;

const BreakdownSection = ({
  classificationCode,
  classificationLabel,
  classifiedLines,
  budgetAmount,
  budgetSubItems = [],
  quantity,
}) => {
  const fmt = (val) => {
    if (val == null || val === '' || val === 0) return '';
    const n = parseFloat(val);
    if (isNaN(n)) return '';
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const actualTotal = classifiedLines.reduce(
    (sum, l) => sum + (parseFloat(l.invoice_amount) || 0),
    0
  );

  const sumType = (lineType) =>
    classifiedLines
      .filter((l) => l.line_type === lineType)
      .reduce((s, l) => s + (parseFloat(l.invoice_amount) || 0), 0);

  const sectionVariance =
    (parseFloat(budgetAmount) || 0) -
    sumType('PURCHASE_ORDER') -
    sumType('INCOMING_INVOICE') +
    sumType('DEBIT_NOTE');

  const q = parseFloat(quantity) || 0;

  return (
    <>
      <tr className="fc-breakdown-header">
        <td colSpan="17">{classificationLabel}:</td>
      </tr>
      <tr className="fc-breakdown-col-header">
        <th>Type</th>
        <th>Classify</th>
        <th>Partner</th>
        <th>Description</th>
        <th>Inv. Date</th>
        <th>Curr.</th>
        <th>Amt/Unit</th>
        <th>Inv. Amt</th>
        <th>USD</th>
        <th>FX</th>
        <th>Paid/Rec.</th>
        <th>Open</th>
        <th>Budget</th>
        <th>Variance</th>
        <th>Due</th>
        <th>Paid</th>
        <th></th>
      </tr>

      {/* Budget sub-items from the linked Budget Calculator */}
      {budgetSubItems.length > 0 &&
        budgetSubItems.map((bItem) => {
          const ba = parseFloat(bItem.budget_amount) || 0;
          const apu = q > 0 ? ba / q : 0;
          return (
            <tr key={`bsub-${bItem.id}`} className="fc-data-row fc-breakdown-budget-row">
              <td className="fc-type-cell">
                <span className="fc-line-label fc-budget-sub-label">{bItem.line_label}</span>
              </td>
              <td className="fc-na-bg">{NA}</td>
              <td className="fc-budget-source">{bItem.partner_name || ''}</td>
              <td className="fc-budget-source">{bItem.description || ''}</td>
              <td className="fc-na-bg">{NA}</td>
              <td className="fc-na-bg">{NA}</td>
              <td className="fc-amount-cell">{fmt(apu)}</td>
              <td className="fc-amount-cell fc-na-bg">{NA}</td>
              <td className="fc-amount-cell fc-na-bg">{NA}</td>
              <td className="fc-amount-cell fc-na-bg">{NA}</td>
              <td className="fc-amount-cell fc-na-bg">{NA}</td>
              <td className="fc-amount-cell fc-na-bg">{NA}</td>
              <td className="fc-amount-cell fc-budget-highlight">{fmt(ba)}</td>
              <td className="fc-amount-cell fc-na-bg">{NA}</td>
              <td className="fc-na-bg">{NA}</td>
              <td className="fc-na-bg">{NA}</td>
              <td></td>
            </tr>
          );
        })}

      {/* Classified actual invoice lines from the top half */}
      {classifiedLines.map((line) => (
        <tr key={line.id} className="fc-data-row fc-breakdown-line">
          <td className="fc-type-cell">
            <span className="fc-line-label">{line.line_label || line.line_type_label || ''}</span>
          </td>
          <td>{classificationLabel}</td>
          <td>{line.partner || ''}</td>
          <td>{line.description || ''}</td>
          <td>{line.invoice_date || ''}</td>
          <td>{line.invoice_currency || ''}</td>
          <td className="fc-amount-cell">
            {q > 0 ? fmt((parseFloat(line.invoice_amount) || 0) / q) : ''}
          </td>
          <td className="fc-amount-cell">{fmt(line.invoice_amount)}</td>
          <td className="fc-amount-cell fc-usd-cell">{fmt(line.converted_amount_usd)}</td>
          <td className="fc-amount-cell">
            {line.fx_rate_used ? parseFloat(line.fx_rate_used).toFixed(4) : '-'}
          </td>
          <td className="fc-amount-cell">{fmt(line.amount_paid)}</td>
          <td className="fc-amount-cell">{fmt(line.amount_open)}</td>
          <td className="fc-amount-cell fc-na-bg">{NA}</td>
          <td className="fc-amount-cell fc-na-bg">{NA}</td>
          {classificationCode === 'COMMISSIONS' ? (
            <td>{line.due_date || ''}</td>
          ) : (
            <td className="fc-na-bg">{NA}</td>
          )}
          <td className="fc-na-bg">{NA}</td>
          <td></td>
        </tr>
      ))}

      {classifiedLines.length === 0 && budgetSubItems.length === 0 && (
        <tr className="fc-data-row fc-breakdown-empty">
          <td colSpan="17" className="fc-empty-msg">
            No invoices classified as {classificationLabel}
          </td>
        </tr>
      )}

      {/* Section summary: budget vs actual vs variance */}
      <tr className="fc-breakdown-summary">
        <td colSpan="7" className="fc-breakdown-summary-label">
          {classificationLabel} Total
        </td>
        <td className="fc-amount-cell">{fmt(actualTotal)}</td>
        <td colSpan="4"></td>
        <td className="fc-amount-cell">{fmt(budgetAmount)}</td>
        <td className={`fc-amount-cell fc-variance-cell ${sectionVariance < 0 ? 'fc-negative' : ''}`}>
          {fmt(sectionVariance)}
        </td>
        <td colSpan="3"></td>
      </tr>
    </>
  );
};

export default BreakdownSection;
